// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"styles__boxWrapper___3uIcb","boxTitle":"styles__boxTitle___36Re-","boxCount":"styles__boxCount___3hZGJ"};